// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Fym7J","content":"styles_content__1kn-E","tableWrap":"styles_tableWrap__3_M9a"};